import { View, Image} from 'react-native-web';

const Logo =()=>{
return (
    
    <Image style={{width:'90%', height:'20%', shadowOffset:{width:5, height:5}, shadowRadius:2.5, shadowOpacity:0.5,  alignSelf:'center', marginTop:15}} resizeMode={'contain'} source={require('../../assets/logoGold.png')}/>);}

const ImageFull =({image, hsize,})=>{
    
return(
<View style={{width:'90%', height:hsize ,marginTop:15, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, borderRadius:16, alignSelf:'center', backgroundColor:'#202020'}}>
 <Image style={{width:'100%', height:'100%', borderRadius:16, overflow:'hidden',}}  resizeMode={'cover'} source={image}/>
</View>);}

const ImageFullHome =({image, hsize,})=>{
    
    return(
    <View style={{width:'90%', height:hsize ,marginTop:15, shadowOffset:{width:10, height:5}, shadowRadius:10, shadowOpacity:0.5, borderRadius:16, alignSelf:'center', backgroundColor:'#202020'}}>
     <Image style={{width:'100%', height:'100%', borderRadius:16, overflow:'hidden',}}  resizeMode={'cover'} source={image}/>
    </View>);}

const Maps =props=>{
    return (
        <View style={{width:'90%', height:'45%' ,marginTop:15, shadowOffset:{width:5, height:5}, shadowRadius:10, shadowOpacity:0.5, borderRadius:16, alignSelf:'center'}}> 
        <Image style={{width:'100%', height:'100%', borderRadius:16, overflow:'hidden'}} resizeMode={'cover'} source={props.source}/>
        </View>);}

const LogoTribu =props=>{
    return (
        
        <Image style={{width:props.wsize, height:props.hsize, shadowOffset:{width:5, height:5}, shadowRadius:2.5, shadowOpacity:0.5,  alignSelf:'center', marginTop:15}} resizeMode={'contain'} source={props.source}/>);}
        const LogoTribu1 =props=>{
            return (
                
                <Image style={{width:props.wsize, height:props.hsize, shadowOffset:{width:5, height:5}, shadowRadius:2.5, shadowOpacity:0.5,  alignSelf:'center'}} resizeMode={'contain'} source={props.source}/>);}
export {Logo, ImageFull, Maps, LogoTribu, LogoTribu1, ImageFullHome}